import { Icon } from '@smartgift/frontend-toolkit';
import { flexRender } from '@tanstack/react-table';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import SelectionHead from '../Header/SelectionHead';

import * as S from './style';

function Thead({ table, components }) {
  const rowSelectionArray = useMemo(() => {
    const { rowSelection } = table.getState();
    return Object.keys(rowSelection);
  }, [table.getState()?.rowSelection]);

  return (
    <S.Thead>
      {rowSelectionArray.length > 0 && (
        <SelectionHead table={table} SelectionHead={components.SelectionHead} />
      )}

      {table.getHeaderGroups().map(headerGroup => (
        <S.Tr key={headerGroup.id}>
          {headerGroup.headers.map(header => {
            return (
              <S.Th
                key={header.id}
                style={{
                  minWidth: header.getSize() || 'auto'
                }}
              >
                {header.isPlaceholder ? null : (
                  <S.HeaderSortable
                    sortable={header.column.getCanSort()}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {header.column.getIsSorted() && (
                      <S.TableSortArrow>
                        {header.column.getIsSorted() === 'desc' ? (
                          <Icon name="up" px={15} />
                        ) : (
                          <Icon name="down" px={15} />
                        )}
                      </S.TableSortArrow>
                    )}
                  </S.HeaderSortable>
                )}
              </S.Th>
            );
          })}
        </S.Tr>
      ))}
    </S.Thead>
  );
}

Thead.propTypes = {
  table: PropTypes.shape({
    getState: PropTypes.func,
    getHeaderGroups: PropTypes.func
  }).isRequired,
  components: PropTypes.shape({
    SelectionHead: PropTypes.node
  })
};

export { Thead };
